import DynamicRatingWidget from './component'

export default DynamicRatingWidget
